import { useTranslation } from 'react-i18next';

import { WidgetCard } from 'us-react-components/dist/WidgetCard/WidgetCard';
import { computed } from 'mobx';
import { useDependencies } from '../../../../../dependencies';
import { splitTextIntoTwoParts } from '../../../../../utils';
import { Strings } from '../../../../../constants';

export const BringYourOwnProvider = (): JSX.Element => {
  const { t } = useTranslation();
  const { stores } = useDependencies();
  const { byopDescription } = stores.parent;

  const {
    firstPart: description,
    secondPart: moreDescription,
  } = computed(() => splitTextIntoTwoParts(byopDescription, Strings.DEFAULT_TRUNCATE_LIMIT)).get();

  return (
    <WidgetCard
      title={t('dashboard.widgets.bringYourOwnProvider.title')}
      description={description}
      moreDescription={moreDescription}
    />
  );
};
